<main class="flex flex-col h-full gap-6">
    <div class="flex flex-col h-full gap-6">
        <h4>스케줄 설정</h4>
        <app-hint>기기의 스케줄 외 시간에는 운영 상태가 '비활성으로 전환되며, 설정된 기본 화면이 자동으로 표시됩니다.'</app-hint>
        <div class="flex flex-col gap-6 py-6 border-y">
            <section class="flex items-center justify-between">
                <p class="font-medium text-gray-700">스케줄 사용 / 미사용</p>
                <app-toggle [(value)]="scheduleEnabled" />
            </section>
            @if (scheduleEnabled()) {
                <section class="flex flex-col gap-2 py-6 border-y">
                    <app-select
                        label="날짜/요일"
                        required="true"
                        [(value)]="scheduleType"
                        bindLabel="label"
                        bindValue="value"
                        size="sm"
                        [options]="selectOptions"
                    />
                    @if (scheduleType() === 'daterange') {
                        <app-input-date-picker label="시작 날짜" [(value)]="startDate" size="sm" />
                        <app-input-date-picker label="종료 날짜" [(value)]="endDate" size="sm" />
                    }
                    @if (scheduleType() === 'day') {
                        <div class="flex items-center gap-3">
                            @for (item of dayItems; track $index) {
                                <button
                                    [ngClass]="seletedDays().includes(item.value) ? 'bg-primary text-white' : 'bg-white text-gray-800'"
                                    (click)="seleteDay(item.value)"
                                    class="flex items-center justify-center border rounded-full size-10"
                                >
                                    <p class="text-sm font-medium">{{ item.label }}</p>
                                </button>
                            }
                        </div>
                    }
                </section>
                <section class="flex flex-col gap-2">
                    <div class="flex items-center justify-between">
                        <app-label [required]="true">시간 설정</app-label>
                        <app-toggle [(value)]="timeActive"></app-toggle>
                    </div>
                    @if (timeActive()) {
                        <div class="flex items-center w-full gap-2">
                            <app-input-time [(value)]="startTime" class="w-full"></app-input-time>
                            <p>-</p>
                            <app-input-time [(value)]="endTime" class="w-full"></app-input-time>
                        </div>
                    }
                </section>
            }
        </div>
    </div>
    <app-button (click)="submit()" expand="true">등록</app-button>
</main>
